import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ButtonListFilterControl } from '~/components/filters/ButtonListFilterControl';
import { RangeFilterControl } from '~/components/filters/RangeFilterControl';

import useApplyFilters from '~/core/filters/hooks/useApplyFilters';
import closeFilt from '~/images/close-filters.svg';

export default function CatalogFilters(props) {
	const [isVisible, setIsVisible] = useState(true);
	const { t } = useTranslation();
	const { resetFilters } = useApplyFilters();

	//console.log(props.filters)
	const closeFilters = () => {
		setIsVisible(isVisible => !isVisible);
	};

	useEffect(() => {
		props.toggleFunc(isVisible);
	}, [isVisible]);

	const renderFilterControls = filterList => {
		var controls = [];

		// Render filters
		for (let flt of props.filters) {
			switch (flt.tp) {
				case 1: // Category
					controls.push(
						<ButtonListFilterControl key={'cat-fltp-' + flt.id} placeholder={t('filter_categories')} filter={flt} name="category-filter" />
					);
					break;
				case 2: // Attribute
					controls.push(<ButtonListFilterControl key={'attr-fltp-' + flt.id} placeholder={flt.nm} filter={flt} name="attribute-filter" />);
					break;
				case 3: // Status
					controls.push(
						<ButtonListFilterControl key={'stat-fltp-' + flt.id} placeholder={t('filter_condition')} filter={flt} name="status-filter" />
					);
					break;
				case 4: // Color
					controls.push(
						<ButtonListFilterControl key={'color-fltp-' + flt.id} placeholder={t('filter_color')} filter={flt} name="color-filter" />
					);
					break;
				case 5: // Size
					controls.push(
						<ButtonListFilterControl key={'size-fltp-' + flt.id} placeholder={t('filter_size')} filter={flt} name="size-filter" />
					);
					break;
				case 6: // Manufacturer
					controls.push(
						<ButtonListFilterControl key={'brand-fltp-' + flt.id} placeholder={t('filter_brand')} filter={flt} name="brand-filter" />
					);
					break;
				case 7: // Model
					controls.push(
						<ButtonListFilterControl key={'model-fltp-' + flt.id} placeholder={t('filter_model')} filter={flt} name="model-filter" />
					);
					break;
				case 8: // Price
					controls.push(<RangeFilterControl key={'price-fltp-' + flt.id} placeholder={t('filter_price')} filter={flt} />);
					break;
				default:
					console.debug('Invalid filter type: ' + flt.tp);
					break;
			}
		}

		return <ul className="filters-list">{controls}</ul>;
	};

	return (
		<>
			<div className="product-filters">
				<div className="header-filters">
					<div className="flex-col">
						<h2>{t('filters_title')}</h2>
						<button onClick={closeFilters} type="button">
							<img src={closeFilt} />
						</button>
					</div>
					<Link className="clear-all" to="#" onClick={resetFilters}>
						{t('clear_filters')}
					</Link>
				</div>
				{renderFilterControls()}
				<div className="footer-filters mobile641">
					<button type="button" onClick={closeFilters} className="see-results see-more">
						{t('see_results')}
						{props.product_count != null ? <span> ({props.product_count})</span> : null}
					</button>
				</div>
			</div>
		</>
	);
}

CatalogFilters.propTypes = {
	toggleFunc: PropTypes.func,
	filters: PropTypes.any,
	product_count: PropTypes.number
};
